import script from "./StockChangeHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./StockChangeHistory.vue?vue&type=script&setup=true&lang=js"

import "./StockChangeHistory.vue?vue&type=style&index=0&id=e85a38b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e85a38b8"]])

export default __exports__